import { render, staticRenderFns } from "./PaginaCancelarReserva.vue?vue&type=template&id=bf05151e&scoped=true&"
import script from "./PaginaCancelarReserva.vue?vue&type=script&lang=js&"
export * from "./PaginaCancelarReserva.vue?vue&type=script&lang=js&"
import style0 from "./PaginaCancelarReserva.vue?vue&type=style&index=0&id=bf05151e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05151e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VOverlay,VProgressCircular,VRow,VSpacer})
